module.exports = __webpack_public_path__ + "static/media/sales.9b2784c0.svg";